<section>
  <p class="section-title">VÍNCULO COM EMPRESA</p>

  <mat-form-field
    appearance="outline"
    class="full-width"
    [class.error]="touchedEmpresa && !empresaSelecionada"
  >
    <mat-label>Vincular empresa*</mat-label>
    <input
      matInput
      type="text"
      [(ngModel)]="empresaDummyModel"
      name="empresaSelecionada"
      [value]="empresaSelecionada?.nomeFantasia || ''"
      readonly
      [disabled]="formBloqueado() || empresaSelecionada"
      (click)="!empresaSelecionada && abrirModalEmpresas()"
      [ngStyle]="!empresaSelecionada ? { cursor: 'pointer' } : {}"
    />
  </mat-form-field>

  <p
    *ngIf="touchedEmpresa && !empresaSelecionada"
    style="
      color: #ba1a1a;
      font-size: 12px;
      margin-top: -10px;
      margin-bottom: 20px;
    "
  >
    Empresa obrigatória
  </p>

  <div class="endereco-empresa-selecionada-card" *ngIf="empresaSelecionada">
    <p>{{ empresaSelecionada?.nomeFantasia }}</p>
    @if(!formBloqueado()) {
    <img
      src="../../../../assets/svg/icons/trash.svg"
      (click)="abrirDesvincularEmpresa()"
      style="cursor: pointer"
    />
    }
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Vincular endereço*</mat-label>
    <input
      matInput
      type="text"
      [value]="enderecoSelecionado?.labelEndereco || ''"
      readonly
      [disabled]="!empresaSelecionada || enderecoSelecionado"
      (click)="empresaSelecionada && !enderecoSelecionado && abrirModalEnderecos()"
      [ngStyle]="empresaSelecionada && !enderecoSelecionado ? { cursor: 'pointer' } : {}"
    />
  </mat-form-field>

  <p
    class="erro"
    *ngIf="touchedEndereco && empresaSelecionada && !enderecoSelecionado"
    style="
      color: #ba1a1a;
      font-size: 12px;
      margin-top: -10px;
      margin-bottom: 20px;
    "
  >
    Endereço obrigatório
  </p>

  <div class="endereco-empresa-selecionada-card" *ngIf="enderecoSelecionado">
    <p>{{ enderecoSelecionado.labelEndereco }}</p>

    @if(!formBloqueado()) {
    <img
      src="../../../../assets/svg/icons/trash.svg"
      (click)="abrirDesvincularEndereco()"
      style="cursor: pointer"
    />
    }
  </div>

  <!--  -->
  @if (linhasDeCuidado.length > 0) {
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Vincular linha de cuidado*</mat-label>
    <input
      matInput
      type="text"
      [value]="linhasDeCuidado[0]?.nome || ''"
      readonly
      [disabled]="true"
    />
  </mat-form-field>

  <div class="endereco-empresa-selecionada-card" *ngIf="linhasDeCuidado">
    <p>{{ linhasDeCuidado[0]?.nome }}</p>
  </div>
  }
</section>

<section style="margin-top: 3em">
  <p class="section-title">DADOS GERAIS</p>
  <mat-grid-list cols="6" rowHeight="90px" gutterSize="1em">
    <mat-grid-tile [colspan]="3">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Naturalidade</mat-label>
        <mat-select
          [(ngModel)]="nacionalidade"
          name="nacionalidade"
          required
          (ngModelChange)="onChangeNacionalidade($event)"
          #nacionalidadeRef="ngModel"
          [disabled]="formBloqueado()"
        >
          <mat-option *ngFor="let opt of nacionalidadeOptions" [value]="opt"
            >{{ opt }}</mat-option
          >
        </mat-select>
        <mat-error *ngIf="nacionalidadeRef.invalid && nacionalidadeRef.touched"
          >Campo obrigatório</mat-error
        >
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="3">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Documento de identificação</mat-label>
        <mat-select
          [(ngModel)]="tipoDocumento"
          name="tipoDocumento"
          required
          [disabled]="formBloqueado() || nacionalidade === 'Brasileiro'"
          #tipoDocumentoRef="ngModel"
        >
          <mat-option *ngFor="let opt of tipoDocumentosOptions" [value]="opt">
            {{ opt }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="tipoDocumentoRef.invalid && tipoDocumentoRef.touched">
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="3">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Número do documento</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="numeroDocumento"
          name="numeroDocumento"
          required
          minlength="3"
          #numeroDocumentoRef="ngModel"
          [mask]="getMascaraTipoDocumento(tipoDocumento)"
          [disabled]="formBloqueado()"
        />
        <mat-error
          *ngIf="numeroDocumentoRef.invalid && numeroDocumentoRef.touched"
        >
          Obrigatório (mín. 3 caracteres)
        </mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="3">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Nome completo</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="nomeCompleto"
          name="nomeCompleto"
          required
          minlength="3"
          #nomeCompletoRef="ngModel"
          [disabled]="formBloqueado()"
        />
        <mat-error *ngIf="nomeCompletoRef.invalid && nomeCompletoRef.touched">
          Nome obrigatório (mín. 3 caracteres)
        </mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="2">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Data de nascimento</mat-label>
        <input
          matInput
          type="date"
          [(ngModel)]="dataNascimento"
          name="dataNascimento"
          required
          #dataNascimentoRef="ngModel"
          [disabled]="formBloqueado()"
        />
        <mat-error
          *ngIf="dataNascimentoRef.invalid && dataNascimentoRef.touched"
        >
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="2">
      <app-country-picker
        [nacionalidade]="nacionalidade"
        [paisPredefinido]="country()"
        class="full-width"
        (countrySelected)="onCountrySelected($event)"
        required
      ></app-country-picker>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="2">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Telefone celular</mat-label>
        <input
          matInput
          type="text"
          [mask]="mascaraTelefone()"
          [(ngModel)]="telefoneCelular"
          [dropSpecialCharacters]="false"
          name="telefoneCelular"
          required
          #telefoneCelularRef="ngModel"
        />
        <mat-error
          *ngIf="telefoneCelularRef.invalid && telefoneCelularRef.touched"
        >
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <div
    style="display: flex; align-items: center; gap: 1.5em; margin-top: 0.5em"
  >
    <p style="color: #606a73">Sexo*:</p>
    <mat-radio-group
      [(ngModel)]="sexo"
      name="sexo"
      required
      #sexoRef="ngModel"
      aria-label="Select an option"
      style="display: flex; flex-direction: row; gap: 2em"
      [disabled]="formBloqueado()"
    >
      <mat-radio-button *ngFor="let opt of sexoOptions" [value]="opt"
        >{{ opt }}</mat-radio-button
      >
    </mat-radio-group>
    <mat-error
      *ngIf="sexoRef.invalid && sexoRef.touched"
      style="margin-left: 1em"
    >
      Selecione uma opção
    </mat-error>
  </div>
</section>

<section style="margin-top: 5em">
  <p class="section-title">DADOS SÓCIODEMOGRÁFICOS</p>
  <mat-grid-list cols="3" rowHeight="90px" gutterSize="1em">
    <mat-grid-tile>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Classificação étnico-racial</mat-label>
        <mat-select
          [(ngModel)]="etnicoRacional"
          name="etnicoRacial"
          [disabled]="formBloqueado()"
        >
          <mat-option *ngFor="let opt of etnicoRacionalOptions" [value]="opt"
            >{{ opt }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Estado civil</mat-label>
        <mat-select
          [(ngModel)]="estadoCivil"
          name="estadoCivil"
          [disabled]="formBloqueado()"
        >
          <mat-option *ngFor="let opt of estadoCivilOptions" [value]="opt"
            >{{ opt }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Grau de escolaridade</mat-label>
        <mat-select
          [disabled]="formBloqueado()"
          [(ngModel)]="escolaridade"
          name="escolaridade"
        >
          <mat-option *ngFor="let opt of escolaridadeOptions" [value]="opt"
            >{{ opt }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>UF</mat-label>
        <mat-select
          [(ngModel)]="ufResidencia"
          (selectionChange)="onChangeUF($event.value)"
          name="ufResidencia"
          [disabled]="formBloqueado()"
        >
          <mat-option value="">Selecione</mat-option>
          <mat-option *ngFor="let uf of ufOptions" [value]="uf.id_uf">
            {{ uf.nome }} ({{ uf.sigla }})
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="2">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Cidade de residência</mat-label>
        <mat-select
          [(ngModel)]="cidadeResidencia"
          name="cidadeResidencia"
          [disabled]="!ufResidencia || formBloqueado()"
        >
          <mat-option value="">Selecione</mat-option>
          <mat-option
            *ngFor="let cidade of cidadeOptions"
            [value]="cidade.id_cidade"
          >
            {{ cidade.nome }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
</section>

<section style="margin-top: 4em">
  <p class="section-title">DADOS TRABALHISTAS</p>
  <mat-grid-list cols="2" rowHeight="90px" gutterSize="1em">
    <mat-grid-tile>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Cargo</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="cargo"
          name="cargo"
          [disabled]="formBloqueado()"
        />
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Área</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="area"
          name="area"
          [disabled]="formBloqueado()"
        />
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Turno</mat-label>
        <mat-select
          [formControl]="turnos"
          multiple
          name="turnos"
          [disabled]="formBloqueado()"
        >
          <mat-option *ngFor="let opt of turnoOptions" [value]="opt">
            <mat-checkbox [checked]="turnoShouldBeChecked(opt)"
              >{{ opt }}</mat-checkbox
            >
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Situação</mat-label>
        <mat-select
          [(ngModel)]="situacao"
          name="situacao"
          #situacaoRef="ngModel"
          [disabled]="formBloqueado()"
        >
          <mat-option *ngFor="let opt of situacaoOptions" [value]="opt"
            >{{ opt }}</mat-option
          >
        </mat-select>
        <mat-error *ngIf="situacaoRef.invalid && situacaoRef.touched"
          >Campo obrigatório</mat-error
        >
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
</section>

<div style="margin-top: 3em; display: flex; gap: 1em; justify-content: end">
  <button matButton="outlined" (click)="cancelar()">Cancelar</button>
  <button matButton="filled" (click)="onTouchedAll(); salvaPessoa()">
    Salvar
  </button>
</div>
